import ReactECharts from 'echarts-for-react'

interface DailyCost {
  date: string
  calls: number
  credits: number
}

interface CostEvolutionChartProps {
  data: DailyCost[]
  unitCost: number
  height?: number
}

export default function CostEvolutionChart({ data, unitCost, height = 280 }: CostEvolutionChartProps) {
  if (data.length === 0) {
    return (
      <div className="flex items-center justify-center rounded-xl border border-[#E2E4ED] bg-[#F8F9FC] p-8" style={{ height }}>
        <p className="text-sm text-[#8B8FA7]">Aucune donnée sur cette période</p>
      </div>
    )
  }

  const option = {
    tooltip: {
      trigger: 'axis' as const,
      backgroundColor: '#1B2559',
      borderColor: '#2D3A6A',
      textStyle: { color: '#E2E4ED', fontSize: 12 },
      formatter: (params: any) => {
        const p = params[0]
        const cost = (p.data * unitCost).toFixed(4)
        return `${p.axisValue}<br/>Appels: ${p.data}<br/>Coût: $${cost}`
      },
    },
    grid: { top: 10, right: 20, bottom: 30, left: 50 },
    xAxis: {
      type: 'category' as const,
      data: data.map((d) => d.date),
      axisLabel: { color: '#8B8FA7', fontSize: 11 },
      axisLine: { lineStyle: { color: '#E2E4ED' } },
    },
    yAxis: {
      type: 'value' as const,
      axisLabel: { color: '#8B8FA7', fontSize: 11 },
      splitLine: { lineStyle: { color: '#F0F1F7' } },
    },
    series: [{
      type: 'bar',
      data: data.map((d) => d.calls),
      itemStyle: {
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: '#6366F1' },
            { offset: 1, color: '#4F46E5' },
          ],
        },
        borderRadius: [4, 4, 0, 0],
      },
    }],
  }

  return (
    <div className="rounded-xl border border-[#E2E4ED] bg-white p-4">
      <ReactECharts option={option} style={{ height }} />
    </div>
  )
}
